import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { QualifiedShareDividendFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const QualifiedShareDividendRejectForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (
  props,
  ref
) => {
  return (
    <GenericForm<QualifiedShareDividendFormTypes.Reject>
      formRef={ref}
      {...props}
      fields={{
        message: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
        },
      }}
    />
  );
};

export default forwardRef(QualifiedShareDividendRejectForm);
